export default 'Énergie B2B & CEE tertiaire | Solution Éco France';
